/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Download_Mac_Step3Inputs */

const en_gc_resources_download_mac_step3 = /** @type {(inputs: Gc_Resources_Download_Mac_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open GridCraft from Applications, then open a copy of your XLSX workbook.`)
};

const zh_gc_resources_download_mac_step3 = /** @type {(inputs: Gc_Resources_Download_Mac_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从“应用程序”启动 GridCraft，然后打开 XLSX 工作簿副本。`)
};

/**
* | output |
* | --- |
* | "Open GridCraft from Applications, then open a copy of your XLSX workbook." |
*
* @param {Gc_Resources_Download_Mac_Step3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_download_mac_step3 = /** @type {((inputs?: Gc_Resources_Download_Mac_Step3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Download_Mac_Step3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_download_mac_step3(inputs)
	return zh_gc_resources_download_mac_step3(inputs)
});
export { gc_resources_download_mac_step3 as "gc.resources.download.mac.step3" }